import script from "./doctorSchedule.vue?vue&type=script&setup=true&lang=js"
export * from "./doctorSchedule.vue?vue&type=script&setup=true&lang=js"

import "./doctorSchedule.vue?vue&type=style&index=0&id=64186151&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Acer\\Desktop\\mav\\surkhet\\patient-portal-v2\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64186151"]])

export default __exports__